<template>

    <video
        v-bind="$attrs"
        :controls="videoControls"
        :autoplay="videoAutoplay"

        ref="video">
        <source v-if="videoSrc" :src="videoSrc" type="video/mp4">
    </video>

    <div v-if="playButtonVisible" class="media__play-icon" @click="play">
        <slot name="icon"></slot>
    </div>

</template>

<script>


export default {
    name: 'levelx-video',

    props: {
        src: {
            type: String,
            required: true
        },
        controls: {
            type: Boolean,
            default: false
        },
        autoplay: {
            type: Boolean,
            default: true
        },
    },



    data() {
        return {
            started: false
        }
    },

    computed: {

        videoControls() {
            return this.started && this.controls;
        },

        videoAutoplay() {
            return this.autoplay;
        },

        // Autoplay laedt die Datei sofort komplett - beim Hero-Loop sind das ~30 MB.
        // Auf schmalen Viewports liefern wir deshalb nur das poster aus, sofern eines
        // gesetzt ist; ohne poster bliebe die Buehne leer, dann laedt das Video wie bisher.
        // Ohne autoplay reicht preload="metadata", da faellt kein voller Download an.
        videoSrc() {
            const skip = this.autoplay
                && Boolean(this.$attrs.poster)
                && window.matchMedia('(max-width: 768px)').matches;

            return skip ? null : this.src;
        },

        playButtonVisible() {
            return !this.started && !this.videoAutoplay;
        }
    },


    methods: {

        play() {
            this.$refs.video.play();
            this.started = true;
        }
    }

}
</script>
